import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      margin: auto;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import { FetchingStatus } from '@scp/ui-shared/core'; // eslint-disable-next-line import/no-relative-parent-imports

import { EmptyList } from '../EmptyList'; // eslint-disable-next-line import/no-relative-parent-imports

import { Loader } from '../Loader'; // eslint-disable-next-line import/no-relative-parent-imports

import { Button } from '../buttons/Button';
var TEXT = {
  REFRESH_BTN: 'Try Again',
  DEFAULT_FAILURE_TEXT: 'Failed to load data'
};
var FailedState = styled(EmptyList)(_templateObject(), function (props) {
  return props.alignCenter && css(_templateObject2());
});
/**
 * Loading Wrapper component.
 *
 * @example ./__docs__/LoadingWrapper.md
 */

export function LoadingWrapper(_ref) {
  var status = _ref.status,
      children = _ref.children,
      onReload = _ref.onReload,
      _ref$failureText = _ref.failureText,
      failureText = _ref$failureText === void 0 ? TEXT.DEFAULT_FAILURE_TEXT : _ref$failureText,
      _ref$showLoader = _ref.showLoader,
      showLoader = _ref$showLoader === void 0 ? true : _ref$showLoader,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? Loader : _ref$component,
      _ref$alignCenter = _ref.alignCenter,
      alignCenter = _ref$alignCenter === void 0 ? false : _ref$alignCenter;

  if (status === FetchingStatus.Initial) {
    return null;
  }

  if (status === FetchingStatus.Loading) {
    var LoaderComponent = component;
    return showLoader ? React.createElement(LoaderComponent, null) : null;
  }

  if (status === FetchingStatus.Failed) {
    return React.createElement(FailedState, {
      title: failureText,
      alignCenter: alignCenter
    }, React.createElement(Button, {
      secondary: true,
      onClick: onReload
    }, TEXT.REFRESH_BTN));
  }

  return children;
}